import { DefaultPageTemplate } from '@/modules/common/components/default-page-template';
import styles from './index.module.sass';
import { MainLogoPlainIcon } from '@/modules/common/icons/logo.icons';
import { HomeLogoClippedIconImage } from '@@/home/images';
import { useState } from 'react';
import { RegisterIntro } from '../../components/register-intro';
import { RegisterShield } from '../../components/register-shield';
import { ButtonMain } from '@/modules/common/components/button';
import { useNavigate } from 'react-router-dom';

export const RegisterPage = () => {
  const [activeStep, setActiveStep] = useState(0);
  const navigate = useNavigate();
  return (
    <DefaultPageTemplate className={styles.root}>
      <header className={styles.header}>
        <div className={styles.header__actions}>
          <div className={styles.title}>Регистрация</div>
        </div>
        <div className={styles.logoPlain}>
          <MainLogoPlainIcon />
        </div>
      </header>

      <div className={styles.content}>
        { activeStep === 0 ? <RegisterIntro setActiveStep={setActiveStep}/> : <RegisterShield onClose={() => setActiveStep(0)}/>}
      </div>

      <footer className={styles.footer}>
        <b>Storage, Blend & Trade</b> - это сервис учета хранения и миксования
        агрокультур, <br /> который помогает увеличивать прибыль и снижать расходы на
        хранение и логистику
        <div className={styles.action}>
          <ButtonMain className={styles.goBack} label="вернуться на главную" onClick={() => navigate('/')}/>
        </div>
      </footer>
      

      <img className={styles.logoClippedIcon} src={HomeLogoClippedIconImage} alt="bg" />
    </DefaultPageTemplate>
  );
};
